import React, { useState } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import DialogHeader from 'components/DialogHeader/DialogHeader';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import {
  DialogActions,
  DialogContent,
  Divider,
  Typography,
  Grid,
  Checkbox,
} from '@material-ui/core/';

import { ChromePicker } from 'react-color';

import Icon from '@mdi/react';
import {
  mdiCheck,
  mdiClose,
  mdiContentSaveOutline,
  mdiInformationOutline,
  mdiPalette,
} from '@mdi/js';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as projectFormActions from 'scenes/ProjectForms/store/actions/projectFormActions';
import Button from 'components/Button/Button';
import ButtonLoading from 'components/ButtonLoading/ButtonLoading';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    ...theme.component.dialogPaper,
  },
  btnCloseDialog: {
    backgroundColor: 'white',
    boxShadow: theme.shadows[3],
    color: theme.palette.textBlack.primary,
    height: 24,
    width: 24,
    position: 'absolute',
    marginTop: '-30px',
    marginLeft: '28px',
    '&:active, &:hover': {
      backgroundColor: 'white',
    },
  },
  iconCloseDialog: {
    height: 16,
    width: 16,
  },
  dialogContent: {
    paddingTop: 8,
    paddingBottom: theme.spacing(3),
    //[theme.breakpoints.down('xs')]: {
    //	padding: '0 8px 8px 8px',
    //}
  },
  dialogActions: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    justifyContent: 'space-between',
  },
  actionBtnDelete: {
    marginRight: 'auto',
  },
  gridItem: {
    //padding: '0 8px',
  },
  removeRecordDialogContent: {
    paddingTop: 20,
  },
  appBar: {
    boxShadow: 'none',
    marginBottom: theme.spacing(1),
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: 0,
  },
  altCloseBtn: {
    color: 'inherit',
    padding: 0,
  },
  menuItem: {
    //color: theme.palette.textBlack.primary,
    //padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    //fontSize: '0.87rem',
    //minHeight: theme.spacing(4)
  },
  datesContainer: {
    //padding: '0 8px',
  },
  inTime: {
    marginRight: '2%',
    float: 'right',
  },
  clockedIcon: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0.5em',
    float: 'right',
  },
  dateItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .rdt': {
      flex: 1,
    },
  },
  clockedText: {
    //marginLeft: '10%',
    //marginTop: '1.5em',
  },
  hidden: {
    display: 'none',
  },
  menuPaper: {
    maxHeight: 200,
  },
  notJoined: {
    color: 'red',
  },
  leafletContainer: {
    height: '800px',
    width: '100%',
  },
  questionContainer: {
    backgroundColor: theme.palette.primary.dark,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  wrongAnswer: {
    outline: '2px solid red',
  },
  rightAnswer: {
    outline: '2px solid green',
  },
  loadingContainer: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: 400,
  },
}));

const ColorPickerDialog = (props) => {
  const { open, onClose, handleColorChange, mainColor } = props;

  const classes = useStyles();
  const { t } = useTranslation('common');

  const [loading, setLoading] = useState(false);

  const [color, setColor] = useState(mainColor);

  const handleColorAccept = () => {
    handleColorChange(color);
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="color-picker-dialog"
      classes={{ paper: classes.dialogPaper }}
      disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
    >
      <DialogHeader
        icon={<Icon path={mdiPalette} size={1} className={classes.icon} />}
        onClose={onClose}
        title={'Valitse väri'}
      />

      <DialogContent>
        <Grid container justifyContent="center" alignItems="center">
          <ChromePicker color={color} onChange={setColor} disableAlpha />
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          className={classes.actionBtn}
          onClick={handleColorAccept}
          color="dark"
        >
          {t('common.select')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPickerDialog;
